module.exports = __webpack_public_path__ + "static/torrecera-logo-525d813b2d6b4bd559a9de2a75233022.jpg";